import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { PATHS } from 'shared/paths';
import { Section, SubSection, Page } from 'shared/location-enums';
import { Article } from 'shared/types';

@Component({
    selector: 'diagnostic-journey',
    templateUrl: './diagnostic-journey.component.html',
    styleUrls: ['./diagnostic-journey.component.scss'],
})
export class DiagnosticJourneyComponent {
    private readonly desktopBreakpoint = 992;
    private readonly mobileClampLines = 8;
    private readonly unclampedLines = 1000;

    public article: Article;
    public articlesInfographic: Article[] = [];
    public imgAltText = '';
    public assetsPath = PATHS.assets;

    public title1 = '';
    public title2 = '';
    public title3 = '';
    public title4 = '';

    imgUrl: string;
    bodyMaxLines = this.unclampedLines;

    constructor(private articleService: ArticleService, @Inject(DOCUMENT) private document: Document) {
        this.setBodyMaxLines();
        this.articlesInfographic = this.articleService.getArticles(Page.diagnosis, Section.parent, SubSection.infographicText, undefined, undefined, false);

        if (this.articlesInfographic.length === 4) {
            this.title1 = this.articlesInfographic[0].title;
            this.title2 = this.articlesInfographic[1].title;
            this.title3 = this.articlesInfographic[2].title;
            this.title4 = this.articlesInfographic[3].title;
        }

        const articlesAll = this.articleService.getArticles(Page.diagnosis, Section.parent, undefined, undefined, undefined, false);

        const articlesActuallyUndefined = articlesAll.filter((a: Article) => a.subSection === undefined);

        this.article = articlesActuallyUndefined[0];

        // there is more than one match, need to merge KAs
        if (this.article && this.article.images && this.article.images.length) {
            this.imgUrl = PATHS.articleImages + this.article.images[0].url + '-800.webp';
        }
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.setBodyMaxLines();
    }

    private setBodyMaxLines() {
        const width = this.document.defaultView?.innerWidth ?? this.desktopBreakpoint;
        this.bodyMaxLines = width >= this.desktopBreakpoint ? this.unclampedLines : this.mobileClampLines;
    }
}
